<ion-button fill="clear" color="dark" (click)="toggleView()">
  <ion-icon [name]="view.expertMode ? 'shapes-outline' : 'school-outline'" slot="start"></ion-icon>
  <ion-label class="ion-text-wrap" [hidden]="!view.isDesktop">
    <h5 [innerHTML]="('view_mode'|translate) + ':'"></h5>
    <small [innerHTML]="(!!view && !!view.expertMode ? 'view_mode_expert' : 'view_mode_simple')|translate"></small>
  </ion-label>
</ion-button>